import { makeStyles } from "@mui/styles";
import { UiText } from "../common/ui/UiText";
import { toRem16 } from "../../scss/utils/styles";
import thumbsup from "../../assets/thumbsup.gif";

const useStyles = makeStyles(() => {
    return {
        container: {
            textAlign: "center",
            marginTop: toRem16(150),
            padding: toRem16(24)
        },
        thumbsUp: {
            width: toRem16(80),
            height: toRem16(80),
            marginBottom: toRem16(40)
        },
        heading: {
            marginBottom: toRem16(16),
        },
    };
});

const Submitted = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div>
                <img className={classes.thumbsUp} src={thumbsup} alt="thumbs-up" />
            </div>
            <div className={classes.heading}>
                <UiText
                    variant="truck_175"
                    typographyVariant="truck_175"
                    weight="bold_700"
                >
                    Your information was successfully submitted to your employer
                </UiText>
            </div>
            <UiText>
                If you need to make any adjustments to your information contact
                your employer.
            </UiText>
        </div>
    );
};

export default Submitted;
